<!--
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  const colors = require('tailwindcss/colors')

  module.exports = {
    // ...
    theme: {
      extend: {
        colors: {
          'light-blue': colors.lightBlue,
          teal: colors.teal,
          rose: colors.rose,
        }
      }
    }
  }
  ```
-->
<template>
    <customer-app-layout>
        <link-customer />
        <div class="flex justify-between items-center max-w-2xl mx-auto">
            <div>
                <h1 class="text-4xl font-bold mb-2">Hallo Niklas</h1>
                <p class="mb-2">Kund*innennummer</p>
                <p class="font-bold mb-4">XXXXXXX</p>
                <a href="#" class="text-purple-300 hover:text-purple-200">Persönliche Details</a>
                <br>
                <a href="#" class="text-purple-300 hover:text-purple-200">E-Mail-Verlauf</a>
            </div>
            <div>
                <!-- Placeholder for the user image -->
                <img src="https://placehold.co/150x150" alt="User profile placeholder image" class="rounded-full border-4 border-white">
            </div>
        </div>
        <!-- Referral section -->
        <div class="bg-white p-4 my-4 rounded-lg">
            <div class="flex justify-between items-center">
                <div>
                    <!-- Placeholder for the octopus image -->
                    <img src="https://placehold.co/100x100" alt="Two octopuses with globe pattern on a pink background" class="rounded-full">
                </div>
                <div>
                    <h2 class="text-2xl">Freund*in werben &amp; gewinnen</h2>
                    <p>
                        Wirb im November so viele Freund*innen wie möglich und sichere dir zusätzlich zum Freund*in-werben Bonus die Chance auf ein unvergessliches Abenteuer deiner Wahl bei Jochen Schweizer.
                    </p>
                    <button class="bg-purple-500 text-white rounded py-2 px-4 my-4">
                        Jetzt am Gewinnspiel teilnehmen
                    </button>
                </div>
            </div>
        </div>

        <!-- Address and energy details -->
        <div class="bg-white p-4 my-4 rounded-lg">
            <div class="text-center">
                <div>Teststr 1, 40333 Düsseldorf</div>
                <div class="py-4 bg-purple-800 rounded my-4">
                    <div class="py-2">In Belieferung</div>
                    <div class="text-4xl font-bold">Strom</div>
                    <div class="text-2xl py-4">Nächster Abschlag</div>
                    <div class="text-4xl pb-4">41,72 €</div>
                    <div>fällig am 25.1.2024</div>
                    <div>per SEPA-Lastschrift</div>
                    <!-- Additional details -->
                    <div>Zählernummer: XXXXXXX</div>
                    <div>In Belieferung seit 7.1.2023</div>
                    <!-- Links -->
                    <a href="#" class="underline text-purple-300">Zahlungsdetails &gt;</a>
                    <a href="#" class="underline text-purple-300">Zählerstand einreichen &gt;</a>
                    <!-- ... other links ... -->
                </div>
            </div>
        </div>
    </customer-app-layout>
</template>

<script>
import {
    AcademicCapIcon,
    BadgeCheckIcon,
    CashIcon,
    ClockIcon,
    ReceiptRefundIcon,
    UsersIcon,
    MailIcon,
    OfficeBuildingIcon,
    ViewListIcon,
    UploadIcon,
    CreditCardIcon,
    ShoppingCartIcon,
    TableIcon
} from '@heroicons/vue/solid'
import CustomerAppLayout from "@/Layouts/CustomerAppLayout";
import FarmTitle from "@/Layouts/FarmTitle";
import LinkCustomer from '../../Modules/CustomerApp/LinkCustomer.vue';

const actions = [
    {
        title: 'Pferde',
        desc: 'Pferde einsehen',
        href: route('horses.index'),
        icon: TableIcon,
        iconForeground: 'text-green-700',
        iconBackground: 'bg-green-100',
    },
    {
        title: 'Produkte',
        desc: 'Produkte und Preise einsehen und bearbeiten',
        href: route('products.index'),
        icon: ShoppingCartIcon,
        iconForeground: 'text-yellow-700',
        iconBackground: 'bg-yellow-100',
    },
    {
        title: 'Kunden',
        desc: 'Kunden verwalten',
        href: route('customers.index'),
        icon: UsersIcon,
        iconForeground: 'text-pink-700',
        iconBackground: 'bg-pink-100',
    },
    {
        title: 'Newsletter',
        desc: 'Newsletter versenden, oder Abonennten verwalten',
        href: route('email.index'),
        icon: MailIcon,
        iconForeground: 'text-gray-700',
        iconBackground: 'bg-gray-100',
    },
    {
        title: 'SEPA',
        desc: 'SEPA-Mandate einsehen, erstellen und löschen',
        href: route('sepa.index'),
        icon: CreditCardIcon,
        iconForeground: 'text-indigo-700',
        iconBackground: 'bg-indigo-100',
    },
    {
        title: 'Exportpunkt erstellen',
        desc: 'Exportpunkt erstellen',
        href: route('exports.index'),
        icon: UploadIcon,
        iconForeground: 'text-red-700',
        iconBackground: 'bg-red-100',
    }
]

export default {
    title: 'Start',
    components: {
    FarmTitle,
    CustomerAppLayout,
    LinkCustomer
},
    setup() {
        return {
            actions,
        }
    },
}
</script>

